import { createApp } from 'vue';
import BmpToPngConverter from '../Components/BmpToPngConverter.vue';

const root = document.getElementById('bmp-to-png-converter');
if (root) {
  createApp(BmpToPngConverter).mount('#bmp-to-png-converter');
}
